<template>
    <div class="container mt-nav z-index">
        <Head title="ثبت کلمه عبور" />
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <div class="col-12 col-md-10">
                        <p class="text-title text-white text-center pb-3">لطفا یک کلمه عبور جدید برای خود تعریف کنید
                            </p>
                        <form @submit.prevent="store">
                            <text-input  dir="ltr" type="password" v-model="form.password" :error="form.errors.password" class="my-3" placeHolder=" کلمه عبور" />
                            <text-input  dir="ltr" type="password" v-model="form.repeat_password" :error="form.errors.repeat_password" class="my-3" placeHolder="تکرار کلمه عبور" />

                            <div class="mt-5 text-center">
                                <loading-button :loading="form.processing" class="tn border-0 btn-orange w-100-btn" type="submit">ثبت کلمه عبور</loading-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Head } from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../../Shared/Layouts/LayoutFirstRegister";
import { Link } from "@inertiajs/inertia-vue3";
import TextInput from "../../Shared/Forms/TextInput";
import LoadingButton from "../../Shared/Layouts/LoadingButton";

export default {
    components: {
        TextInput,
        LoadingButton,
        Head,
        Link
    },
    layout: LayoutFirstRegister,
    data() {
        return {
            form: this.$inertia.form({
                password: '',
                repeat_password: '',
            }),
        }
    },
    methods: {
        store() {
            this.form.post('/new-password-store' , {
                onSuccess: (data) => {

                }
            })
        },
    },
    mounted() {
        this.$refs.mobile.focus();
    },
    metaInfo() {
        return {
            meta : [
                {name : 'description' , content : 'hello is my desd'}
            ]
        }

    }
}

</script>

<style scoped>

</style>
